module.exports = __webpack_public_path__ + "static/img/doctor-right-bg.4775b51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shapes/doctor-right-bg.jpg
// module id = hSe7
// module chunks = 0